import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GiCakeSlice, GiPartyPopper } from "react-icons/gi";
import { BsStars } from "react-icons/bs";
import { cloudFrontUrl } from "../../nestserver";
import { selectUser } from "../../redux/slices/auth.slice";
import { isBirthdayToday } from "../../utils/birthday";

export default function FriendsCard({ data }) {
  const [url, setUrl] = useState("/");

  const user = useSelector(selectUser);
  const navigate = useNavigate();

  function getUrl() {
    switch (user?.role) {
      case "admin":
        return `/dashboard/admin/instructor/profile/${data?._id}`;

      case "instructor":
        return `/dashboard/instructor/menu/friends/${data?._id}`;

      case "student":
        return `/dashboard/student/menu/friends/${data?._id}`;

      default:
        break;
    }
  }
  useEffect(() => {
    if (user) {
      setUrl(getUrl());
    }
  }, [user]);
  const isBirthday = isBirthdayToday(data?.dob);

  const cardStyle = isBirthday
    ? {
        background:
          "linear-gradient(135deg, #fff0f6 0%, #fff2e2 50%, #fffbea 100%)",
        border: "1.5px solid #f9a8d4",
        boxShadow: "0 6px 24px rgba(236, 72, 153, 0.28)",
      }
    : undefined;

  return (
    <div
      className="iskool-friends-card flex space-x-3 cursor-pointer"
      style={cardStyle}
      onClick={() => navigate(url)}
    >
      <div className="w-20 h-20 relative">
        {isBirthday && (
          <>
            <span className="absolute -inset-1 rounded-full bg-pink-400 opacity-60 animate-ping" />
            <BsStars
              className="absolute -top-3 -left-3 text-amber-400 text-2xl animate-pulse"
              style={{ animationDelay: "0.2s" }}
            />
            <BsStars
              className="absolute -top-2 -right-4 text-pink-400 text-xl animate-pulse"
              style={{ animationDelay: "0.6s" }}
            />
          </>
        )}
        <img
          className={
            "relative w-full h-full object-cover rounded-full" +
            (isBirthday ? " ring-4 ring-pink-400" : "")
          }
          src={
            data?.profile_image
              ? cloudFrontUrl + "/" + data?._id + "/" + data?.profile_image
              : "https://ui-avatars.com/api/?name=" + data?.first_name
          }
          alt={data?.first_name}
        />
        {isBirthday && (
          <span
            className="absolute -bottom-2 -right-2 bg-linear-to-br from-pink-500 to-orange-400 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg animate-bounce"
            title="Birthday today!"
          >
            <GiCakeSlice className="text-2xl" />
          </span>
        )}
      </div>
      <div className="w-0 flex-grow flex flex-col justify-center">
        <div
          className={
            "font-bold flex items-center gap-2" +
            (isBirthday ? " text-pink-600" : "")
          }
        >
          {data?.first_name} {data?.last_name}
          {isBirthday && (
            <GiPartyPopper className="text-pink-500 text-xl animate-bounce" />
          )}
        </div>
        <div
          className={
            "text-xs line-clamp-2 pt-2" +
            (isBirthday
              ? " text-amber-600 font-semibold"
              : " text-gray-500")
          }
          style={{ minHeight: "25px" }}
        >
          {data?.class?.name}
        </div>
        {isBirthday && (
          <div className="text-sm font-bold text-pink-600 animate-pulse flex items-center gap-1">
            🎉 Happy Birthday!
          </div>
        )}
      </div>
    </div>
  );
}
